//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Indicator } from 'src/index';

export default {
  methods: {
    openIndicator() {
      Indicator.open();
      setTimeout(() => Indicator.close(), 2000);
    },

    openIndicatorWithSpinner() {
      Indicator.open({ spinnerType: 'fading-circle' });
      setTimeout(() => Indicator.close(), 2000);
    },

    openIndicatorWithText() {
      Indicator.open('加载中...');
      setTimeout(() => Indicator.close(), 2000);
    }
  },

  beforeDestroy() {
    Indicator.close();
  }
};



// WEBPACK FOOTER //
// ./example/pages/indicator.vue